import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterHTML} from "../helpers/filters";

interface Data {
    paragraphById: {
        fieldVarCustomBodyContent: string;
    }
}

class CustomBlockQuery extends Query<Data, {id: string}> {}

const GET_CARDS = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on ParagraphComponentCustomBlock {
      fieldVarAdditionalCss
      fieldVarCustomBodyContent
      fieldIsComponent
    }
  }
}
`;

const CustomBlock = ({id, markComponentLoadedAs}) => (
    <CustomBlockQuery asyncMode query={GET_CARDS} variables={{ id }}>
        {({ loading, error, data }) => {
            /* eslint-disable react/no-danger */
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            markComponentLoadedAs(id, true);

            let additionalClasses = '';
            if (field.fieldIsComponent) {
                additionalClasses += ' componentContainer';
            }
            if (field.fieldVarAdditionalCss) {
                additionalClasses += ` ${field.fieldVarAdditionalCss}`
            }

            return (
                <div className={`container${additionalClasses}`}>
                    <div>{filterHTML(field.fieldVarCustomBodyContent, true)}</div>
                </div>
            );
        }}
    </CustomBlockQuery>
);

CustomBlock.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default CustomBlock;



// WEBPACK FOOTER //
// ./frontend/components/CustomBlock.jsx